import React from 'react';
import { Accordion } from 'react-bootstrap';
import '../css/FAQComponent.css'; 
import FAQData from '../data/FAQData'; // Ensure the path is correct based on your project structure

const FAQ = () => {
  return (
    <section className="faq-section mt-5">
      <h2 className="text-center mb-4">Frequently Asked Questions</h2>
      <Accordion>
        {FAQData.map((question, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
          <Accordion.Header>
            <h5 className="faq-header">{question.header}</h5>
          </Accordion.Header>
          <Accordion.Body>{question.body}</Accordion.Body>
        </Accordion.Item>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQ;
